import React, {useState, useEffect} from "react";

// components

import CardStats from "components/Cards/CardStats.js";
import { fetchSiswa, fetchUser, fetchTentor, fetchRekap } from "components/Service/API";

export default function HeaderStats() {
  const [dataSiswa, setDataSiswa] = useState([]);
  const [dataUser, setDataUser] = useState([]);
  const [dataTentor, setDataTentor] = useState([]);
  const [dataRekap, setDataRekap] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  useEffect(() => {
    async function loadSiswaData() {
      try {
        const data = await fetchSiswa();
        setDataSiswa(data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setErr(err);
      }
    }
    async function loadUserData(){
      try{
        const data = await fetchUser();
        setDataUser(data);
      }catch(e){
        console.log(e);
      }
    }
    async function loadTentorData(){
      try{
        const data = await fetchTentor();
        setDataTentor(data)
      }catch(e){
        console.log("tentor error", e);
      }
    }
    async function loadRekapData(){
      try{
        const data = await fetchRekap();
        setDataRekap(data);
      }catch(e){
        console.log("rekap error", e)
      }
    }

    loadSiswaData();
    loadUserData();
    loadTentorData();
    loadRekapData();
  }, []); // Dependency array kosong untuk memanggil effect sekali saat komponen dimuat
  

  return (
    <>
      {/* Header */}
      <div className="relative bg-lightBlue-600 md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="Siswa"
                  statTitle={loading? "Memuat" : dataSiswa.length}
                  statIconName="fas fa-child"
                  statIconColor="bg-red-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="USERS"
                  statTitle={loading? "Memuat" : dataUser.length}
                  statIconName="fas fa-user-alt"
                  statIconColor="bg-orange-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="TENTOR"
                  statTitle={loading? "Memuat" : dataTentor.length}
                  statIconName="fas fa-user-graduate"
                  statIconColor="bg-pink-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="Presensi"
                  statTitle={loading? "Memuat" : dataRekap.length}
                  statIconName="fas fa-folder"
                  statIconColor="bg-lightBlue-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
